export const environment = {
  production: true,
  branch: 'branch_val',
  commit: 'commit_val',
  date: 'date_val',
  version: 'version_val',
  int365_api: '#{int365_api}#',
  int365_dom: '#{int365_dom}#',
  ethical_line_reservas: '#{ethical_line_reservas}#',
  client_id: '#{client_id}#',
  inactivity_time_limit_in_minutes: '#{inactivity_time_limit_in_minutes}#',
  out_of_inactivity_time_limit_in_minutes:
    '#{out_of_inactivity_time_limit_in_minutes}#',
  page_size: '#{page_size}#',
  iframe_emisor: '#{iframe_emisor}#',
  iframe_receptor: '#{iframe_receptor}#',
  iframe_slob: '#{iframe_slob}#',
  fe_portal_intermediarios_365_front_faq_document_url: '#{fe_portal_intermediarios_365_front_faq_document_url}#',
  satisfaction_survey_url: '#{satisfaction_survey_url}#',
  ga_measurement_id_intermediarios: '#{ga_measurement_id_intermediarios}#',
  ga_debug_mode_intermediarios: '#{ga_debug_mode_intermediarios}#',
  fe_google_maps_api_key: '#{fe_google_maps_api_key}#',
  fe_google_maps_map_id: '#{fe_google_maps_map_id}#',
};
